<template>
  <select ref="select" class="fake-select">
    <option
      v-for="option in options"
      :key="getKey(option)"
      :value="getKey(option)"
    >
      {{ option.title }}
    </option>
  </select>
</template>

<script>
  import { bem } from 'src/utils/bem.js';

  export default {
    name: 'FakeSelect',
    props: {
      options: {
        type: Array,
        required: true,
      },
    },
    emits: ['input', 'max-width-change'],
    watch: {
      options: {
        deep: true,
        handler() {
          this.updateMaxWidth()
        },
      }
    },
    mounted() {
      this.updateMaxWidth();
    },
    methods: {
      bem,
      updateMaxWidth() {
        this.$emit('max-width-change', this.$refs.select.getBoundingClientRect().width);
      },
      getKey(option) {
        return option.value && typeof option.value === 'object' ? JSON.stringify(option.value) : option.value;
      }
    },
  };
</script>
